import AtcSearchCriteriaGroupItem from './search-criteria-group-item-component';
import AtcSearchCriteriaGroupItemService from './search-criteria-group-item-service';

const MODULE_NAME = 'app.atc.search-criteria-group-item';
const module = angular.module(MODULE_NAME, [])
    .directive(AtcSearchCriteriaGroupItem.DIRECTIVE_NAME, AtcSearchCriteriaGroupItem)
    .service('atcSearchCriteriaGroupItemService', AtcSearchCriteriaGroupItemService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/atc/atc-check-result/search-criteria-group-item/search-criteria-group-item-module.js